import React from 'react';
import styled from 'styled-components';
import { openChargebeeModal } from './initPaypal';
import { PaypalIcon } from 'assets/icons';

export function PayPalButton({
  cbInstance,
  setError,
  currency,
  selectedPlanId,
  _id,
  coupon_ids,
  billingPeriod,
  numberAccounts,
}: any) {
  const openChargeBee = async () => {
    openChargebeeModal(
      cbInstance,
      setError,
      currency,
      selectedPlanId,
      _id,
      coupon_ids,
      billingPeriod,
      numberAccounts,
    );
  };

  return (
    <PayPallButtonContainer>
      <PayPallButtonWrapper onClick={openChargeBee}>
        <span>Pay with </span>
        <PayPallButton>
          <PaypalIcon />
        </PayPallButton>
      </PayPallButtonWrapper>
    </PayPallButtonContainer>
  );
}

const PayPallButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 6px 2px 8px;
  width: 57px;
  background: var(--white);
  border-radius: 16px;
  border: none;
`;

const PayPallButtonContainer = styled.div`
  display: flex;
`;

const PayPallButtonWrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;
  mix-blend-mode: multiply;
  width: 276px;
  cursor: pointer;
  justify-content: center;
  color: var(--Text-T01, #333);
  border-radius: 20px;
  background: var(--Primary-P50, #edeaff);
  /* Text sm/Regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;
